import React from 'react';
import { useFormContext } from "../../context/FormContext/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomElement({
  element
}) {
  const formContext = useFormContext();
  const Component = element.children;
  return /*#__PURE__*/_jsx(Component, {
    ...element.componentProps,
    formContext: formContext
  }, element.id);
}